import proxyRequest, {httpMethods} from 'js/proxy_api_client';

const PostStateMachineApiClient = {
    getGraph(query = {}) {
        return proxyRequest(httpMethods.GET, 'api/v1/campaign_post/post_state/graphs', {
            data: query
        });
    }
};

export default PostStateMachineApiClient;



// WEBPACK FOOTER //
// ./api_clients/post_state_machine_api_client.js